<template>
  <div>
    <b-table
      class="d-none d-md-inline-table"
      ref="table"
      id="my-table" 
      hover 
      head-variant="dark"
      tbody-tr-class="row-center"
      :items="payerReceivedTransactions" 
      :fields="masterTableProps.fields" 
      :per-page="masterTableProps.resultsPerPage"
      xcurrent-page="masterTableProps.currentPage"
      :filter="filter"
      :filter-function="filterTable"
      :sort-by.sync="masterTableProps.sortBy"
      :sort-direction="masterTableProps.sortDirection"
      :sort-desc.sync="masterTableProps.sortDesc"
      show-empty
      @filtered="onFiltered"
      :busy="payerReceivedTransactionsIsBusy"
    >
      <template #empty>
        <empty-table></empty-table>
      </template>
      <template #table-busy>
        <div style="display:flex; justify-content: center">
          <spinner></spinner>
        </div>
      </template>
      <template #cell(created_at)="data">
        {{ new Date(data.item.created_at) | dateFormat('DD/MM/YYYY h:mm A') }}
      </template>
      <template #cell(service_reference)="data">
        <router-link :to="'/transactions/' + data.item.id" class="text-link">
          {{ truncateString(data.item.service_reference) }}
        </router-link>
      </template>
      <template #cell(transaction_amount)="data">
        {{ data.item.currency }} {{ data.item.transaction_amount | currency }}
      </template>
      <template #cell(status)="data">
        <status-button :status="data.item.status" />
      </template>
      <template #cell(view)="data">
        <router-link :to="'/transactions/' + data.item.id">
          <b-button pill variant="primary" class="table-btn px-5 py-1">View</b-button>
        </router-link>
      </template>
    </b-table>

    <table-pagination
      :totalRows="receivedRows"
      @paginationChange="handlePaginationChange"
    />

    <mobile-transaction
      :transactions="payerReceivedTransactions"
      :loading="payerReceivedTransactionsIsBusy"
      :limit="10"
      :hasRoute="true"
      :routerLink="mobileTransactionsConfig.router_link"
      :filter="mobileTransactionsConfig.filter_mobile"
      :type="mobileTransactionsConfig.table_type"
      :search="mobileTransactionsConfig.search"
      xv-if="status === 'received'"
    />
  </div>
</template>
<script>
import store from '../store';
import TransactionAPI from '../api/transactions_api';
import { tableMixin } from '../utils/table.mixin';
import spinner from '../utils/Spinner';
import emptyTable from '../utils/empty-table.vue';
import MobileTransaction from './MobileTransaction.vue';
import StatusButton from './StatusButton.vue';
import TablePagination from './TablePagination.vue';

export default {
  mixins: [
    tableMixin
  ],
  props: [''],
  components: {
    StatusButton,
    MobileTransaction,
    emptyTable,
    spinner,
    TablePagination
  },
  data: () => ({
    mobileTransactionsConfig: {
      filter_mobile: {},
      router_link: '/transactions/',
      table_type: 'vendor transaction',
      search: '',
    }
  }),
  mounted() {
    console.log('transactions received loaded');
    TransactionAPI.methods.getPayerReceivedTransactions();
  },
  methods: {
    handlePaginationChange(page_number) {
      TransactionAPI.methods.getPayerReceivedTransactions({
        ...this.filterProperties,
        page: page_number
      });
    }
  },
  computed: {
    filterProperties: {
      get: function () {
        return store.state.filterProperties;
      },
      set: function (newValue) {
        store.state.filterProperties = newValue;
      }
    },
    receivedRows() {
      return store.state.payerReceivedTransactions.count;
    },
    payerReceivedTransactions: {
      get: function () {
        return store.state.payerReceivedTransactions.results;
      },
      set: function (newValue) {
        store.state.payerReceivedTransactions.results = newValue;
      }
    },
    payerReceivedTransactionsIsBusy() {
      if (this.axiosRequestAmount == 0) {
        return false;
      }

      return true;
    },
    axiosRequestAmount: {
      get: function () {
        return store.state.axiosRequestAmount;
      },
      set: function (newValue) {
        store.state.axiosRequestAmount = newValue;
      }
    },
    rows: {
      get: function() {
        if (!this.filter) {
          //return this.payerReceivedTransactions.length;
          return store.state.payerReceivedTransactions.count;
        } else {
          return this.masterTableProps.totalRows;
        }
      },
      set: function(newValue) {
        this.masterTableProps.totalRows = newValue;
      } 
    }
  }
};
</script>
